// src/components/DashboardCards.jsx
import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import WardMaster from "./WardMaster/WardMaster";
import BedMaster from "./BedMaster/BedMaster";
import BedAvailability from "./BedAvailabilityStatus/BedAvailability";
import WardReports from "./WardReports";
import { decrypt } from "../../components/cryptoUtil";
import DashboardCards from "../HospitalDashBoardCards";
import { includeCardForRoles, ROLES } from "../componenet/heading";


const WardDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


const tokenData = localStorage.getItem("tokenData");
    const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
    const userName = decryptedData.userfullname || "";

const userRole = decryptedData.userrole || "";

const cardRoles = {
  "Ward Master": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Bed Availability Status": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "Bed Master": [ROLES.RECEPTIONIST],
  "Ward Reports": [ROLES.STAFF],
  
};

  const cards = [
     ...includeCardForRoles(cardRoles["Ward Master"], userRole,
{
      title: "Ward Master",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <WardMaster />,category: "👨‍⚕️ Ward Managament",
    }),
     ...includeCardForRoles(cardRoles["Bed Master"], userRole,
{
      title: "Bed Master",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <BedMaster />,category: "👨‍⚕️ Ward Managament",
    }),
     ...includeCardForRoles(cardRoles["Bed Availability Status"], userRole,
{
      title: "Bed Availability Status",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <BedAvailability />,category: "👨‍⚕️ Ward Managament",
    }),
     ...includeCardForRoles(cardRoles["Ward Reports"], userRole,
{
      title: "Ward Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <WardReports /> ,category: "👨‍⚕️ Ward Managament",
    }),
  ];

  
  
     return (
      <DashboardCards
        cards={cards}
        menulabel={1}
        welcomeMessage={
          <Typography variant="h5" align="center" gutterBottom>
              👨‍⚕️ Ward Managament
          </Typography>
        }
      />
    );
  };

export default WardDashBoard;
